import React, { useState } from 'react';
import './faq.css';
import data from './data';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleIndexChange = (currentIndex) => {
    setActiveIndex((prev) => prev === currentIndex ? null : currentIndex);
  };

  return (
    <div className='faq-container'>
      <h3>Frequently Asked Questions</h3>
      {data.map((faq, index) => (
        <div
          className={`faq-box ${index === activeIndex ? 'active' : ''}`}
          key={index}
          onClick={() => handleIndexChange(index)}
        >
          <div className="question">
            <p>{faq.question}</p>
            {
              index === activeIndex ? <i className='bx bx-chevron-up' ></i> : <i className='bx bx-chevron-down' ></i>
            }
          </div>
          <div className="answer">
            <p>{faq.answer}</p>
          </div>
        </div>
      ))}
    </div>
  );
}